import axios, { AxiosResponse } from 'axios';

// DELETE
// Removes temporary profiles from fishgroup.
// /ewosapi/v1/planandprognosis/temporaryprofiles/{fishGroupId}
export const deleteTemporaryPlanningProfile = async (fishGroupId: string, request: number): Promise<AxiosResponse> => {
  return await axios.delete<AxiosResponse>(`/ewosapi/v1/planandprognosis/temporaryprofiles/${fishGroupId}`, { data: [request] });
};
